import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import QualityInspection from "../../entity/emergency/QualityInspection";
import axios from "axios";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";

const SERVICE = "service-emergency";
const ENTITY = "quality_inspections";

/**
 * @rule-checker exclude
 * @returns {*|void|boolean|{findOneById(*): {select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}, validQuotation: function(*): Promise<boolean|undefined>, update(*, *, *): Promise<undefined|*|void|null|boolean>}|Promise<boolean|undefined>|null|{select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}}
 */
export default function () {
    const {findOneBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new QualityInspection(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec(useCache = true) {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "id", id);
                    }

                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7", false, useCache);
                }
            }
        },
        validQuotation: async id => {
            try {
                await axios.post(process.env.REACT_APP_API_URL + `/service-emergency/application_v7/quality_inspections/${id}/validation`, null);

                return true;
            } catch (e) {
                console.log(e)
                return false;
            }
        },
        async update(id, property, payload) {
            if (demo.isLockRequest()) {
                return demo.handleRequest("PATCH", SERVICE, ENTITY, property, payload);
            }

            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        },
    }
}